import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'invoiceStatusTranslator',
})
export class InvoiceStatusTranslatorPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(status: string | undefined, isReturn: boolean = false): string {
    if (!status) {
      return '-';
    }
    const translationKey = isReturn ? `INVOICE.RETURN_STATUS.${status}` : `INVOICE.STATUS.${status}`;
    const translatedValue = this.translateService.instant(translationKey);

    if (isReturn && translatedValue === translationKey) {
      const fallbackKey = `INVOICE.STATUS.${status}`;
      const fallbackValue = this.translateService.instant(fallbackKey);
      return fallbackValue === fallbackKey ? status : fallbackValue;
    }

    return translatedValue === translationKey ? status : translatedValue;
  }
}
